/**
 * client/analytics.ts
 * Responsabilidad: Wrapper de PostHog para tracking de eventos.
 *
 * Si no hay API Key configurada, los eventos van a console.debug.
 * Sin PII (no se envian emails, nombres reales, IPs, etc.).
 */
import posthog from "posthog-js";
import { isCrazyGamesEnvironment } from "./crazygames";

let initialized = false;
let initAttempted = false;

/**
 * Inicializa PostHog con la API key del servidor.
 * La key se inyecta en window.__POSTHOG_CONFIG__ desde el servidor.
 */
export function initAnalytics(): void {
    if (isCrazyGamesEnvironment()) {
        console.log("[Analytics] CrazyGames environment detected. PostHog disabled.");
        return;
    }
    if (initAttempted) return;
    initAttempted = true;

    const config = (window as any).__POSTHOG_CONFIG__;
    if (!config || !config.apiKey) {
        console.log("[Analytics] Modo desarrollo o sin API key. Eventos a console.debug.");
        return;
    }

    try {
        posthog.init(config.apiKey, {
            api_host: config.host || "https://us.i.posthog.com",
            autocapture: false,
            disable_session_recording: true,
            capture_pageview: false,
            persistence: "localStorage",
        });
        initialized = true;
        console.log("[Analytics] PostHog inicializado.");
    } catch (err) {
        console.warn("[Analytics] Error al inicializar PostHog:", err);
    }
}

/**
 * Envia un evento a PostHog (o a console si no esta inicializado).
 */
export function trackEvent(name: string, properties: Record<string, unknown> = {}): void {
    if (isCrazyGamesEnvironment()) return;
    if (!initialized) {
        console.debug(`[Analytics] ${name}`, properties);
        return;
    }
    try {
        posthog.capture(name, properties);
    } catch (err) {
        console.warn("[Analytics] Error al enviar evento:", err);
    }
}
